<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/rate.webp"
  >
    <ng-container i18n
      >Rates represent the price set for a property or service over a period. Actions involve updating or adjusting
      rates, notifying guests, and logging changes. This entity ensures that pricing is accurate and reflects changes
      based on demand, seasons, or promotions.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when a rate is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.RateCreated)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.RateCreated ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Created/Updated
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.RateCreated" [ngTemplateOutlet]="createdEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div></div>
    <div></div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Rate is Created/Updated</h6>
    <ng-template [ngTemplateOutlet]="createdEventTableView"></ng-template>
  </div>
</div>

<ng-template #createdEvent>
  <div class="panel active">
    <div class="d-flex align-items-center">
      <div i18n>Automatically push rates to channels</div>

      <div class="flex-fill"></div>

      <button
        class="btn btn-secondary-info"
        (click)="onConfigure()"
        type="button"
        matTooltip="Coming Soon"
        i18n-matTooltip
        disabled
      >
        <i class="cs-icon cs-icon-cog"></i> <ng-container i18n>Configure</ng-container>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #createdEventTableView>
  <div class="autopilot-automation table-view align-items-center">
    <div i18n>Automatically push rates to channels</div>

    <div></div>

    <div>
      <button
        class="btn btn-secondary-info"
        (click)="onConfigure()"
        type="button"
        matTooltip="Coming Soon"
        i18n-matTooltip
        disabled
      >
        <i class="cs-icon cs-icon-cog"></i><ng-container>&nbsp;</ng-container
        ><ng-container i18n>Configure</ng-container>
      </button>
    </div>
  </div>
</ng-template>
